import PropTypes from 'prop-types';

import { createContext, useEffect, useReducer } from 'react';
// utils

import { apiRouter, axiosGet, axiosPost } from '../services';
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';

import { toastMessages, toastTypes } from '../constants/keywords';

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),

  UPDATE_USER: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
};

const reducer = (state, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
  updateUser: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');
        let accessUser = window.localStorage.getItem('authUser')
          ? JSON.parse(window.localStorage.getItem('authUser'))
          : null;

        if (accessToken) {
          setSession(accessToken);
          const response = await axiosGet(apiRouter.GET_USER_BY_ID.replace(':id', accessUser?._id));
          const { success, data } = response;

          if (success) {
            accessUser = data;
          }

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user: accessUser,
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
        if (!isValidToken(accessToken)) {
          setSession(null);
          dispatch({ type: 'LOGOUT' });
          return;
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (payload) => {
    // setSession(JSON.stringify(payload));
    const response = await axiosPost(apiRouter.LOGIN, payload);
    const { msg, success, data, accessToken } = response;
    if (!success) {
      console.log(msg || toastMessages.GENERAL_ERROR, toastTypes.ERROR);
      return response;
    }
    if (success) {
      setSession(accessToken);
      localStorage.setItem('authUser', JSON.stringify(data));
      dispatch({
        type: 'LOGIN',
        payload: {
          user: data,
        },
      });
      return response;
    }
  };

  const logout = async () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  };

  const updateUser = async (userData) => {
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      let accessUser = window.localStorage.getItem('authUser')
        ? JSON.parse(window.localStorage.getItem('authUser'))
        : null;

      if (accessToken) {
        if (userData) {
          accessUser = userData;
        }

        dispatch({
          type: 'UPDATE_USER',
          payload: {
            isAuthenticated: true,
            user: accessUser,
          },
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        updateUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
